import axios from 'axios'

export default axios.create({
    baseURL: process.env.BASE_URL + 'api/app',
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    }
})